import { render, staticRenderFns } from "./AbastecimentoPrincipal.vue?vue&type=template&id=8a1f74c2&"
import script from "./AbastecimentoPrincipal.vue?vue&type=script&lang=js&"
export * from "./AbastecimentoPrincipal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports